<template>
	<div class="map" id="signMap"></div>
</template>
<script>
	import ahData from "@/common/china";
	export default {
		mounted() {
			this.initMapChart();
		},
		methods: {
			initMapChart() {
				let mapChart = this.$echarts.init(document.getElementById('signMap'));
				this.$echarts.registerMap("ah", ahData);	
				var list = [
					{
						name: "合肥市",
						piece:3,
						info:"黄陂湖大闸蟹<br>三河米酒<br>丰乐酱干",
					},{
						name: "六安市",
						piece:11,
						info:"六安瓜片<br>霍山黄芽<br>漫水河百合<br>霍山石斛<br>迎驾贡酒<br>霍山灵芝<br>霍山黄大茶",
					},{
						name: "淮南市",
						piece:2,
						info:"八公山豆腐<br>潘集酥瓜",
					},{
						name: "滁州市",
						piece:6,
						info:"滁菊<br>明绿御酒<br>女山湖大闸蟹<br>明光绿豆<br>来安花红<br>龙岗芡实",
					},{
						name: "马鞍山市",
						piece:4,
						info:"石臼湖螃蟹<br>和县黄金瓜<br>运漕酒（运酒）<br>含眉绿茶",
					},{
						name: "芜湖市",
						piece:0.5,
						info:"凤丹<br>南陵大米",
					},{
						name: "铜陵市",
						piece:2.5,
						info:"铜陵白姜<br>凤丹<br>枞阳媒鸭",
					},{
						name: "安庆市",
						piece:13,
						info:"胡玉美蚕豆辣酱<br>天柱山瓜蒌籽<br>舒席<br>岳西茭白<br>岳西翠兰<br>岳西桑皮纸<br>岳西黑猪<br>黄湖大闸蟹<br>天华谷尖<br>怀宁贡糕<br>龙池香尖<br>桐城水芹",
					},{
						name: "池州市",
						piece:3,
						info:"石台富硒茶<br>西山焦枣<br>九华黄精",
					},{
						name: "黄山市",
						piece:12,
						info:"徽墨<br>歙砚<br>黄山毛峰茶<br>太平猴魁茶<br>黄山贡菊<br>大方茶<br>黄山白茶<br>三潭枇杷<br>五城茶干<br>松萝茶<br>万安罗盘<br>五城米酒<br>安茶",
					},{
						name: "宣城市",
						piece:7,
						info:"宣纸<br>宁国山核桃<br>宁国笋干<br>小窖宣酒<br>宣城木榨油<br>南丰黄酒<br>徽墨<br>歙砚",
					},{
						name: "蚌埠市",
						piece:3,
						info:"沱湖螃蟹<br>怀远石榴<br>白莲坡贡米",
					},{
						name: "淮北市",
						piece:4,
						info:"口子窖酒<br>塔山石榴<br>段园葡萄<br>临涣酱包瓜",
					},{
						name: "阜阳市",
						piece:3,
						info:"金种子酒<br>黄岗柳编<br>李兴桔梗",
					},{
						name: "宿州市",
						piece:5,
						info:"砀山酥梨<br>符离集烧鸡<br>灵璧石<br>大路口山芋<br>萧县葡萄",
					},{
						name: "亳州市",
						piece:4,
						info:"亳白芍<br>涡阳苔干<br>高炉家酒<br>古井贡酒",
					},
				]
				const option = {
					// 提示框组件
					tooltip: {
						trigger: 'item', 
						formatter: function (val) {
							return val.data.name + '<br>' + val.data.info
						}
					},
					series: [
						{
							type: 'map',
							map: "ah", //上面引入的数据名
							mapType: 'china',
							zoom:1.24,
							label: {
								normal: {
									show: true,
									color: '#fff',
									fontSize:14,
									formatter: function (params) {
										return params.name+"\n"+ '地标：' + params.data.piece;    //地图上展示文字 + 数值
									},
								},
							},
							itemStyle: {
								normal: {
									borderWidth:1,
									borderColor: "#07E2F4", //地图区域的边框
									areaColor: "#2498CF",
								},
								emphasis: { 
									label: {
										color: "#fff",
										show: true ,
									},
									areaColor: "#4F7FFF",
								}
							},
							data:list,
						}
					],
				};
				mapChart.setOption(option);
				window.addEventListener("resize", function() {
					mapChart.resize();
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		width: 100%;
		height: 100%;
	}
</style>
